import React from "react";
import { Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/nav.scss";
import MainTabView from "./tabViews/MainTabView";
import NavBar from "./NavBar";

const w = window;

class Nav extends React.Component {
  constructor(props) {
    super(props);
    const algorithm = require("./thumb/Algorithm.png");
    const clipboard = require("./thumb/Clipboard.png");

    this.state = {
      clinicalTool: "",
      disclaimerAccepted: this.checkDisclaimerAcceptance(),
      displayDisclaimer: false,
      displayAboutUs: false,
      mobileNav: false,
      open: false,
      selectedButton: {
        ref: "management",
        control: "nav-home",
        label: "Management",
        card: "",
        color: "#040040",
        buttonImage: algorithm,
        tabImage: clipboard,
      },
    };

    this.handleSelection = this.handleSelection.bind(this);
    this.confirmationTool = this.confirmationTool.bind(this);
    this.disclaimerModal = this.disclaimerModal.bind(this);
    this.dismissModal = this.dismissModal.bind(this);
    this.showAboutUs = this.showAboutUs.bind(this);
    this.showDisclaimer = this.showDisclaimer.bind(this);
  }

  handleSelection(navButton, clearTool) {
    if (clearTool) {
      w["tools_first_page"] = true;
      w["tools_category"] = null;
    }
    this.setState({ selectedButton: navButton, clinicalTool: "" });
  }

  confirmationTool(tool) {
    w.history.pushState({tool: tool.target.id}, null)
    w["tools_first_page"] = false;
    w["tools_category"] = tool.target.id;
    this.setState({ clinicalTool: tool.target.id });
  }

  checkDisclaimerAcceptance() {
    const accepted = this.getCookie("disclaimer_accepted");
    return accepted !== "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  dismissModal() {
    var now = new Date();
    var time = now.getTime();
    time += 24 * 3600 * 1000;
    now.setTime(time);
    document.cookie =
      "disclaimer_accepted=true; expires=" + now.toUTCString() + "; path=/";
    this.setState({
      disclaimerAccepted: true,
      displayDisclaimer: false,
      displayAboutUs: false,
    });
  }

  showDisclaimer() {
    this.setState({ displayDisclaimer: true });
  }

  showAboutUs() {
    this.setState({ displayAboutUs: true });
  }

  modalText() {
    if (this.state.displayAboutUs) {
      const logos1 = require("./thumb/logos1.png");
      const logos2 = require("./thumb/logos2.png");
      const logos3 = require("./thumb/logos3.png");
      return {
        title: "About Us",
        paragraphs: [
          "This app is designed exclusively for the use of health care providers. The information is provided as reference and educational material based on the experiences and opinions of the authors who are providers in Office Based Addiction Treatment who are contributing authors. Some content comes from outside sources. This app is not intended for use to diagnose disease or to cure, mitigate, treat, or prevent any condition or disease. The hospital and the contributors are not acting as health care providers or professional consultants on behalf of any specific patient and disclaim establishing a provider-patient relationship with any specific patient.",
          "In view of the continual changes that occur in medical science, as well as the possibility of human error, the app may contain technical inaccuracies, typographical or other errors. Neither Boston Medical Center nor the content contributors represent or warrant that the information accessible through the app is accurate, complete or current. Users are advised to consult medical literature and to check the product information currently provided by the manufacturer of each drug to be administered or prescribed to verify the recommended dose, the method and duration of administration, and contraindications. It is the responsibility of the treating clinician to rely on their own experience and knowledge about their specific patient to determine dosages and the best treatment for that patient.",
          "The information contained in the app is provided \"as is\" and without warranty of any kind. Boston Medical Center and its employee or staff contributors to the app disclaim responsibility for any errors or omissions or for results obtained from the use of information contained herein. Use of the app is at your own risk. To the maximum extent provided by law, the contributors to the app and BMC disclaim all liability of any kind whether arising in contract, tort, or otherwise in connection with use of the app.",
          "DSM and DSM-5 are registered trademarks of the American Psychiatric Association, and are used with permission herein. Use of these terms is prohibited without permission of the American Psychiatric Association. Use of this trademark does not constitute endorsement of this product by the American Psychiatric Association.",
          "The AUDIT Alcohol Consumption Questions (AUDIT-C) for the diagnosis of alcohol use disorder were developed by Bush et al.: Bush, K., Kivlahan, D. R., McDonell, M. B., Fihn, S. D., & Bradley, K. A. (1998). The AUDIT alcohol consumption questions (AUDIT-C): an effective brief screening test for problem drinking. Archives of internal medicine, 158(16), 1789-1795.",
          "The Clinical Opiate Withdrawal Scale (COWS) was developed by Wesson and Ling: Wesson, D. R., & Ling, W. (2003). The Clinical Opiate Withdrawal Scale (COWS). Journal of psychoactive drugs, 35(2), 253–259.",
          "Development of this application was led by Annie Potter, MSN, MPH, NP, CARN-AP; Andrea Jodat, DNP, FNP-BC, CARN-AP; Shereen Sodder, BA; Tavita Hristova, BS; and Colleen LaBelle MSN, RN-BC, CARN. We would like to thank the entire BMC Grayken Center for Addiction TTA team for their significant contributions to this application.",
          "This project was funded in part by Boston Medical Center and the Massachusetts Department of Public Health's Bureau of Substance Addiction Services. Additionally, funding for this initiative was made possible (in part) by grant no. 6H79TI080816 from SAMHSA. The views expressed in written conference materials or publications and by speakers and moderators do not necessarily reflect the official policies of the Department of Health and Human Services; nor does mention of trade names, commercial practices, or organizations imply endorsement by the U.S. Government.",
          "The clinical management recommendations were last updated on 01/25/2023.",
          "If you have questions or concerns when using this app contact the <a href='https://addictiontraining.org/about-us/contact/' target='_blank'>Grayken Center for Addiction TTA</a>."
        ],
        legal: "© 2023 Boston Medical Center. All rights reserved.",
        images: [
        {
          image: logos1,
          link: 'https://www.addictiontraining.org/'
        },
        {
          image: logos2,
          link: 'https://www.opioidresponsenetwork.org/'
        },
        {
          image: logos3,
          link: 'http://www.mass.gov/dph/'
        }
        ],
      };
    } else {
      return {
        title: "Disclaimer",
        paragraphs: [
          "Welcome to the BMC MAT Quick Start app!",
          "This app is designed exclusively for the use of health care providers. The information is provided as reference and educational material based on the experiences and opinions of the authors who are providers in Office Based Addiction Treatment who are contributing authors. Some content comes from outside sources. This app is not intended for use to diagnose disease or to cure, mitigate, treat, or prevent any condition or disease. The hospital and the contributors are not acting as health care providers or professional consultants on behalf of any specific patient and disclaim establishing a provider-patient relationship with any specific patient.",
          "In view of the continual changes that occur in medical science, as well as the possibility of human error, the app may contain technical inaccuracies, typographical or other errors. Neither Boston Medical Center nor the content contributors represent or warrant that the information accessible through the app is accurate, complete or current. Users are advised to consult medical literature and to check the product information currently provided by the manufacturer of each drug to be administered or prescribed to verify the recommended dose, the method and duration of administration, and contraindications. It is the responsibility of the treating clinician to rely on their own experience and knowledge about their specific patient to determine dosages and the best treatment for that patient.",
          "The information contained in the app is provided \"as is\" and without warranty of any kind. Boston Medical Center and its employee or staff contributors to the app disclaim responsibility for any errors or omissions or for results obtained from the use of information contained herein. Use of the app is at your own risk. To the maximum extent provided by law, the contributors to the app and BMC disclaim all liability of any kind whether arising in contract, tort, or otherwise in connection with use of the app."
        ],
        legal: "© 2023 Boston Medical Center. All rights reserved.",
      };
    }
  }

  disclaimerModal() {
    const text = this.modalText();
    return (
      <Modal
        show={
          !this.state.disclaimerAccepted ||
          this.state.displayDisclaimer ||
          this.state.displayAboutUs
        }
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>{text.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {text.paragraphs.map((p) => (
            <p dangerouslySetInnerHTML={{__html: p}} />
          ))}
          <h6>{text.legal}</h6>
          {(text.images || []).map((i) => (
            <a href={i.link} target="_blank">
              <p style={{textAlign: "center"}}><img className="about-us-logo" src={i.image}></img></p>
            </a>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={this.dismissModal}
            style={{ backgroundColor: "#5368D3" }}
          >
            Accept
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  handleClick() {
    this.setState({
      open: !this.state.open,
    });
  }

  render() {
    this.checkDisclaimerAcceptance();

    if (typeof w["tools_first_page"] === "undefined") {
      w["tools_first_page"] = true;
    }

    const selectedButton = this.state.selectedButton;

    return (
      <div className="full-view">
        <NavBar handleSelection={this.handleSelection}/>
        {this.disclaimerModal()}
        <MainTabView
          id={selectedButton.ref}
          color={selectedButton.color}
          cardClass={selectedButton.card}
          confirmationTool={this.confirmationTool}
          clinicalTool={this.state.clinicalTool}
          buttonImage={selectedButton.buttonImage}
        />
        <div className="footer center">
          <a onClick={this.showAboutUs}>About us</a>
          <a> | </a>
          <a onClick={this.showDisclaimer}>Disclaimer</a>
        </div>
      </div>
    );
  }
}

export default Nav;
